<template>
  <div class="app-product-aid-to-start">
    <div class="app-product-aid-to-start__content">
      <h2 class="app-product-aid-to-start__title">
        {{ title }}
      </h2>

      <p v-if="intro" class="app-product-aid-to-start__intro">
        {{ intro }}
      </p>

      <div class="app-product-aid-to-start__tags">
        <button
          v-for="tag in tags"
          :key="tag.id"
          type="button"
          class="app-product-aid-to-start__tag"
          :class="{ 'app-product-aid-to-start__tag--selected': isSelected(tag.id) }"
          :disabled="!isSelected(tag.id) && selectedIds.length >= MAX_SELECTED"
          :aria-pressed="isSelected(tag.id)"
          @click="toggleTag(tag.id)"
        >
          {{ tag.text }}
        </button>
      </div>
    </div>

    <div class="flex justify-center">
      <TappButton class="app-product-aid-to-start__button" :disabled="selectedIds.length === 0" @click="emit('select')">
        {{ t('marketingPages.productAid.toStart.selectButton') }}<template v-if="selectedIds.length"> ({{ selectedIds.length }})</template>
      </TappButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ProductAidTag } from './AppProductAid.vue';

  const MAX_SELECTED = 3;

  const { t } = useI18n();

  defineProps<{
    title: string;
    intro: string;
    tags: ProductAidTag[];
  }>();

  const selectedIds = defineModel<string[]>({ default: () => [] });

  const emit = defineEmits<{
    select: [];
  }>();

  function isSelected(id: string) {
    return selectedIds.value.includes(id);
  }

  function toggleTag(id: string) {
    if (isSelected(id)) {
      selectedIds.value = selectedIds.value.filter((selectedId) => selectedId !== id);
    } else if (selectedIds.value.length < MAX_SELECTED) {
      selectedIds.value = [...selectedIds.value, id];
    }
  }
</script>

<style lang="postcss" scoped>
  .app-product-aid-to-start {
    display: grid;
    grid-template-rows: 1fr auto;
    flex: 1;
    gap: var(--spacing-6);

    padding: var(--spacing-2);
    border-radius: var(--spacing-1);

    &__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__title {
      margin-bottom: var(--spacing-4);
      color: var(--colors-black);
      text-align: center;
      text-wrap: balance;
    }

    &__intro {
      margin-bottom: var(--spacing-8);
      color: var(--colors-black);
      text-align: center;
      text-wrap: balance;
    }

    &__tags {
      display: flex;
      flex-wrap: wrap;
      gap: var(--spacing-4);
      justify-content: center;
    }

    &__tag {
      cursor: pointer;

      padding: var(--spacing-3) var(--spacing-4);
      border: 1px solid #494e4e;
      border-radius: var(--spacing-1);

      color: var(--colors-black);

      background: var(--colors-white);

      &--selected {
        color: var(--colors-white);
        background: var(--colors-black);
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }
    }
  }
</style>
